__webpack_require__.p = "https://stage.lexhero.com/";